var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-overlay",
    { attrs: { show: _vm.loading } },
    [
      _c("SuccessfulBiddersFilters", {
        attrs: {
          value: _vm.filters,
          onChange: _vm.onChangeFilters,
          clear: _vm.clearFilters
        }
      }),
      _c(
        "div",
        {
          staticClass:
            "text-left mb-2 d-flex justify-content-start align-items-center"
        },
        [
          _c(
            "b-button",
            {
              directives: [
                {
                  name: "has-permission",
                  rawName: "v-has-permission",
                  value: "ED211",
                  expression: "'ED211'"
                }
              ],
              staticClass: "ml-4 badge-glow",
              attrs: { variant: "primary", size: "sm", "data-cy": "add" },
              on: {
                click: function($event) {
                  return _vm.newBidder()
                }
              }
            },
            [_c("span", { staticClass: "align-middle" }, [_vm._v("Nuevo")])]
          ),
          _c(
            "b-button",
            {
              staticClass: "ml-4 badge-glow",
              attrs: { variant: "warning", size: "sm", "data-cy": "download" },
              on: {
                click: function($event) {
                  return _vm.downloadList()
                }
              }
            },
            [
              _c("feather-icon", {
                staticClass: "mr-3",
                attrs: { icon: "DownloadIcon", "data-cy": "download" }
              }),
              _c("span", { staticClass: "align-middle" }, [_vm._v("Descargar")])
            ],
            1
          )
        ],
        1
      ),
      _c("SuccessfulBiddersHeader"),
      _c(
        "div",
        { key: _vm.forceRender, staticClass: "force-render" },
        _vm._l(_vm.filteredSuccessfulBidders, function(bidder) {
          return _c("SuccessfulBidderRow", {
            key: bidder.adjudicatarioId,
            attrs: {
              bidder: bidder,
              reloadList: _vm.reloadList,
              "select-bidder": _vm.selectSuccessfulBidder
            },
            on: { "bidder-save": _vm.handleBidderSave }
          })
        }),
        1
      ),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-3" }, [
          _c("div", { staticClass: "mt-5" }, [
            _vm._v(" Mostrando "),
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.rowspp,
                    expression: "rowspp"
                  }
                ],
                on: {
                  change: [
                    function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.rowspp = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                    function($event) {
                      return _vm.fetchSuccessfulBidders()
                    }
                  ]
                }
              },
              [
                _c("option", { attrs: { value: "10", selected: "selected" } }, [
                  _vm._v(" 10 ")
                ]),
                _c("option", { attrs: { value: "15" } }, [_vm._v("15")]),
                _c("option", { attrs: { value: "30" } }, [_vm._v("30")]),
                _c("option", { attrs: { value: "50" } }, [_vm._v("50")])
              ]
            ),
            _vm._v(" registros por página. ")
          ])
        ]),
        _c(
          "div",
          { staticClass: "col-9" },
          [
            _c("SuccessfulBiddersPagination", {
              attrs: { show: _vm.filteredSuccessfulBidders.length },
              model: {
                value: _vm.page,
                callback: function($$v) {
                  _vm.page = $$v
                },
                expression: "page"
              }
            })
          ],
          1
        )
      ]),
      _c(
        "b-modal",
        {
          ref: "newBidder",
          attrs: {
            title: "Nuevo adjudicatario",
            "no-close-on-backdrop": "",
            size: "lg",
            "hide-footer": ""
          }
        },
        [_c("BidderForm", { on: { "bidder-save": _vm.handleBidderSave } })],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }